module.exports = __webpack_public_path__ + "static/media/Hello-1.7da515a0.mp4";